import { useEffect } from 'react';

/**
 * Meta Pixel — Badminton Class Ready.
 * The single place the pixel is initialised. Only this pixel id is used and
 * PageView is tracked exactly once per page load (guarded against React
 * StrictMode double effects, re-mounts and any pre-existing fbq instance).
 */
const PIXEL_ID = '1461581986119531';
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    __bcrPixelPageViewSent?: boolean;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.__bcrPixelPageViewSent) return;
    window.__bcrPixelPageViewSent = true;
    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue.push(args);
      } as Fbq;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return null;
}